import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { Col, Table, Row, Divider } from 'antd';
import { ExcelIcon } from 'icons';
import { Route, Routes } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useMisteryReports from '../useMisteryReports';
import DeleteModal from 'components/deleteModalView';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    onChangeTableFilter,
    loading,
    handleDownloadExcel,
    onDelete,
    updateInProcess,
  } = useMisteryReports();
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('MYSTERY REPORT').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filterByShoppingCenter filters={filters} />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.mistery_reports}
          pagination={data.pagination}
          scroll={{ x: 1500 }}
          onChange={onChangeTableFilter}
          loading={loading}
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
